export const EditCustomFieldService = Symbol('EditCustomFieldService');
export const EditCustomFieldDialogProxy = Symbol('EditCustomFieldDialogProxy');
